import {useApi} from "../Api";
import {AncillaryDetail, AncillaryDetailCopyRequest} from "../types/ancillaryDetail";
import {AncillaryEntityResponse} from "../types/ancillary";

export const useAncillaryDetailRepository = () => {
    const {GET, POST, PUT} = useApi();

    const PATH = "/pricing/ancillary-detail";

    function getAncillaryDetails(ancillaryId: number): Promise<AncillaryDetail[]> {
        return GET(`${PATH}/price-matrix?ancillaryId=${ancillaryId}`);
    }

    function getAncillaryDetailsFromCopyAncillary(body: AncillaryDetailCopyRequest): Promise<AncillaryDetail[]> {
        return POST(`${PATH}/copy-price-matrix`, body);
    }

    function postAncillaryDetails(ancillaryDetails: AncillaryDetail[]): Promise<AncillaryDetail[]> {
        return POST(`${PATH}/full`, ancillaryDetails);
    }

    function persistAncillaryDetails({
                                         ancillaryId,
                                         ancillaryDetails
                                     }: { ancillaryId: number, ancillaryDetails: AncillaryDetail[] }): Promise<AncillaryDetail[]> {
        return PUT(`${PATH}/update-price-matrix`, {ancillaryId, ancillaryDetails});
    }

    function persistAncillaryAndDetails({
                                            prcAncillary,
                                            ancillaryDetails
                                        }: { prcAncillary: AncillaryEntityResponse, ancillaryDetails: AncillaryDetail[] }): Promise<AncillaryDetail[]> {
        return PUT(`${PATH}/update-price-matrix`, {prcAncillary, ancillaryDetails});
    }

    function deleteAncillaryDetails({ancillaryDetailIds}: { ancillaryDetailIds: number[] }): Promise<number[]> {
        return POST(`${PATH}/full-delete`, ancillaryDetailIds);
    }


    return {
        getAncillaryDetails,
        getAncillaryDetailsFromCopyAncillary,
        persistAncillaryAndDetails
    };
};